export default "__VITE_ASSET__Bj3AspJa__"